import { BillableApi } from "../../../../store/billing/models/internal";
import { FunctionComponent } from "react";
import { KYCCard } from "./kyc";
import { CardProps } from "./default";
import { KYBCard } from "./kyb";
import { AMLCard } from "./individual-aml";

export const cardMap: Partial<
  Record<typeof BillableApi.T, FunctionComponent<CardProps>>
> = {
  KYC: KYCCard,
  KYB: KYBCard,
  BUSINESS_AML: AMLCard,
  INDIVIDUAL_AML: AMLCard,
};
